import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es5.js';
import spartaGlobalFunctions from '@sparta.global.utilities/sparta-global-functions-utility/dist/es5.js';
import _ from '@sparta.global.vendors/lodash';

/**
 * Determines the current environment settings.
 * @returns {object} The settings for `environment` (string) and `isLLE` (boolean).
 */
function _getEnv() {
  var url = window.location.hostname;
  var result = {
    environment: 'PROD',
    isLLE: false
  };
  var cases = {
    cert: {
      environment: 'CERT',
      isLLE: true
    },
    sit: {
      environment: 'SIT',
      isLLE: true
    },
    dev: {
      environment: 'DEV',
      isLLE: true
    },
    '127.0.0.1': {
      environment: 'LOCAL',
      isLLE: true
    },
    localhost: {
      environment: 'LOCAL',
      isLLE: true
    }
  };
  if (cases[url]) {
    result = cases[url];
  }
  if (window.location.protocol === 'file:') {
    result = cases.localhost;
  }
  return result;
}
var _store = {};
var EVENTS = {
  ADD_PERSISTED: 'ADD_PERSISTED.spartaStoreUtility',
  REMOVE_PERSISTED: 'REMOVE_PERSISTED.spartaStoreUtility',
  UPDATE_PERSISTED: 'UPDATE_PERSISTED.spartaStoreUtility'
};

/**
 * The global data store utility for holding page-level module and event information.
 */
var SpartaStoreUtility = /*#__PURE__*/function () {
  /**
   * Initialzes a new instance of the Store Utility with global data defaults.
   */
  function SpartaStoreUtility() {
    _classCallCheck(this, SpartaStoreUtility);
    this._key = 'sparta';
    window.sparta.store = window.sparta.store || {};
    _store.browser = {};
    _store.currentMQ = {
      orientation: null,
      resolution: null,
      viewport: null
    };
    var lang = document.querySelector('html').getAttribute('lang');
    // const htmlLang = lang ? lang.toLowerCase().split("-")[0] : 'en';

    _store.environment = _getEnv().environment;
    _store.isLLE = _getEnv().isLLE;
    _store.lang = lang ? lang.toLowerCase() : 'en-us';
    var _store$lang$split = _store.lang.split('-');
    var _store$lang$split2 = _slicedToArray(_store$lang$split, 1);
    _store.jcrLang = _store$lang$split2[0];
    _store.state = this._getState();
    _store.useLocalStorage = this.checkStorage('localStorage');
    _store.useSessionStorage = this.checkStorage('sessionStorage');
    // _store.bankHolidays = global.spaParams.global[htmlLang].bankHolidays;
  }

  /**
   * @returns {object} The utility's event identifiers.
   */
  return _createClass(SpartaStoreUtility, [{
    key: "EVENTS",
    get: function get() {
      return EVENTS;
    }

    /**
     * Determines whether the data store is working properly.
     * @param {string} storageType - Should be "localStorage" or "sessionStorage".
     * @returns {boolean} Whether the test value could be saved and read back from the store.
     */
  }, {
    key: "checkStorage",
    value: function checkStorage(storageType) {
      var checkStorage = false;
      try {
        var uid = new Date();
        var storage = window[storageType];
        storage.setItem(uid, uid);
        checkStorage = storage.getItem(uid) === uid.toString();
        storage.removeItem(uid);
      } catch (exception) {
        // eslint-disable-next-line no-console
        console.warn("storeUtility: ".concat(storageType, " access is unavailable."));
      }
      return checkStorage;
    }

    /**
     * Persists a given piece of data in the store.
     * @param {string} key - The key name in the store. Can be a path (e.g. "currentMQ.viewport").
     * @param {*} [value] - A piece of data to keep in the store.
     * @param {string} [storageType] - Should be "localStorage" or "sessionStorage".
     * @returns {boolean} Whether the data was added using `addData` or not.
     */
  }, {
    key: "persist",
    value: function persist(key) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var storageType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'localStorage';
      if (!_store.useLocalStorage || !_store.useSessionStorage || storageType.toLowerCase() === 'object') {
        return this.addData(key, value, false);
      }
      var storage = window[storageType];
      var storageData = storage.getItem(this._key);
      var data = storageData === null ? {} : JSON.parse(storageData);
      data[key] = value;
      storage.setItem(this._key, JSON.stringify(data));
      spartaEventsUtility.pub(this.EVENTS.ADD_PERSISTED, {
        key: key,
        value: value
      });
      return false;
    }

    /**
     * Retrieves a persisted piece of data from the store.
     * @param {string} [key] - The key name in the store. Can be a path (e.g. "currentMQ.viewport").
     * @param {string} [storageType] - Should be "localStorage" or "sessionStorage".
     * @returns {*} The value stored under the specified key.
     */
  }, {
    key: "getPersisted",
    value: function getPersisted() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var storageType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'localStorage';
      if (!_store.useLocalStorage || !_store.useSessionStorage || storageType.toLowerCase() === 'object') {
        return this.getData(key);
      }
      var storage = window[storageType];
      var storageData = storage.getItem(this._key);
      var data = storageData === null ? {} : JSON.parse(storageData);
      return data[key];
    }

    /**
     * Removes a persisted piece of data from the store.
     * @param {string} [key] - The key name in the store. Can be a path (e.g. "currentMQ.viewport").
     * @param {string} [storageType] - Should be "localStorage" or "sessionStorage".
     * @returns {boolean} Whether the data was successfully removed or not.
     */
  }, {
    key: "removePersisted",
    value: function removePersisted() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var storageType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'localStorage';
      if (!_store.useLocalStorage || !_store.useSessionStorage || storageType.toLowerCase() === 'object') {
        return this.removeData(key, false);
      }
      var storage = window[storageType];
      var storageData = storage.getItem(this._key);
      var data = storageData === null ? {} : JSON.parse(storageData);
      var isRemoved = false;
      var removedItem;
      if (!key) {
        storage.removeItem(this._key);
        isRemoved = true;
        removedItem = storageData;
      } else if (Object.prototype.hasOwnProperty.call(data, key)) {
        removedItem = data[key];
        delete data[key];
        storage.setItem(this._key, JSON.stringify(data));
        isRemoved = true;
      }
      spartaEventsUtility.pub(this.EVENTS.REMOVE_PERSISTED, Object.assign({
        key: key,
        isRemoved: isRemoved
      }, isRemoved && {
        removedItem: removedItem
      }));
      return isRemoved;
    }

    /**
     * Retrieves and removes a persisted piece of data from the store.
     * @param {string} [key] - The key name in the store. Can be a path (e.g. "currentMQ.viewport").
     * @param {string} [storageType] - Should be "localStorage" or "sessionStorage".
     * @returns {*} The value stored under the specified key.
     */
  }, {
    key: "getAndRemovePersisted",
    value: function getAndRemovePersisted() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var storageType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'localStorage';
      var data = this.getPersisted(key, storageType);
      this.removePersisted(key, storageType);
      return data;
    }

    /**
     * Updates a persisted piece of data in the store.
     * @param {string} key - The key name in the store. Can be a path (e.g. "currentMQ.viewport").
     * @param {*} [newValue] - A piece of data to keep in the store.
     * @param {object} [storageType] - Should be "localStorage" or "sessionStorage".
     * @returns {boolean} Whether the data was successfully updated or not.
     */
  }, {
    key: "updatePersisted",
    value: function updatePersisted(key) {
      var newValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var storageType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'localStorage';
      if (!_store.useLocalStorage || !_store.useSessionStorage || storageType.toLowerCase() === 'object') {
        return this.updateData(key, newValue, false);
      }
      var storage = window[storageType];
      var storageData = storage.getItem(this._key);
      var data = storageData === null ? {} : JSON.parse(storageData);
      var isUpdated = false;
      var oldValue;
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        oldValue = data[key];
        data[key] = newValue;
        storage.setItem(this._key, JSON.stringify(data));
        isUpdated = true;
      }
      spartaEventsUtility.pub(this.EVENTS.UPDATE_PERSISTED, Object.assign({
        key: key,
        newValue: newValue,
        isUpdated: isUpdated
      }, isUpdated && {
        oldValue: oldValue
      }));
      return isUpdated;
    }

    /**
     * Adds data to the store.
     * @param {string} key - The key name in the store. Can be a path (e.g. "currentMQ.viewport").
     * @param {*} val - A piece of data to keep in the store.
     * @param {boolean} [pubEvent] - Should this publish an event?
     * @returns {boolean} Whether the data was successfully added or not.
     */
  }, {
    key: "addData",
    value: function addData(key, val) {
      var pubEvent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var widgetInfo = arguments.length > 3 ? arguments[3] : undefined;
      if (widgetInfo && widgetInfo.id) {
        key = "".concat(key, "_").concat(widgetInfo.id);
      }
      var existing = _.get(_store, key, null);
      var added = false;
      if (existing !== null) {
        this.updateData(key, val);
      } else {
        _.set(_store, key, val);

        // state values persist e.g. NC
        if (key === 'state') {
          this._setState(val);
        }
        added = true;
        if (pubEvent) {
          spartaEventsUtility.pub("".concat(key, "-spartaStore"), {
            action: 'add',
            data: _.get(_store, key, null)
          });
        }
      }
      return added;
    }

    /**
     * Updates data in the store.
     * @param {string} key - The key name in the store. Can be a path (e.g. "currentMQ.viewport").
     * @param {*} val - A piece of data to keep in the store.
     * @param {boolean} [pubEvent] - Should this publish an event?
     * @returns {boolean} Whether the data was successfully updated or not.
     */
  }, {
    key: "updateData",
    value: function updateData(key, val) {
      var pubEvent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var updated = false;
      _.set(_store, key, val);

      // state values persist e.g. NC
      if (key === 'state') {
        this._setState(val);
      }
      updated = true;
      if (pubEvent) {
        spartaEventsUtility.pub("".concat(key, "-spartaStore"), {
          action: 'update',
          data: _.get(_store, key, null)
        });
      }
      return updated;
    }

    /**
     * Retrieves data from the store.
     * @param {string} key - The key name in the store. Can be a path (e.g. "currentMQ.viewport").
     * @returns {*} The value stored under the specified key.
     */
  }, {
    key: "getData",
    value: function getData(key, widgetInfo) {
      if (widgetInfo && widgetInfo.id) {
        key = "".concat(key, "_").concat(widgetInfo.id);
      }
      var data = _.get(_store, key, null);
      if (!key) {
        data = _store;
      }
      return data;
    }

    /**
     * Removes data from the store.
     * @param {string} key - The key name in the store. Can be a path (e.g. "currentMQ.viewport").
     * @param {boolean} [pubEvent] - Should this publish an event?
     * @returns {boolean} Whether the data was successfully removed or not.
     */
  }, {
    key: "removeData",
    value: function removeData(key) {
      var pubEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var removedItem = _.get(_store, key, null);
      var removed = _.unset(_store, key);
      if (pubEvent) {
        spartaEventsUtility.pub("".concat(key, "-spartaStore"), {
          action: 'remove',
          data: {
            removed: removed,
            removedItem: removedItem
          }
        });
      }
      return removed;
    }

    /**
     * @private
     * Retrieves the state code from session storage (locally) or from a cookie.
     * @returns {string} A two-letter state abbreviation (e.g. "NC").
     */
  }, {
    key: "_getState",
    value: function _getState() {
      var state = '';
      if (_store.environment === 'LOCAL' && _store.useSessionStorage) {
        var sessionStorageState = this.getPersisted('spartaState', 'sessionStorage');
        if (sessionStorageState) {
          state = sessionStorageState;
        }
      } else {
        // set cookie
        state = spartaGlobalFunctions.spartaGetCookie('state');
      }
      if (typeof state !== 'string' && state.length !== 2) {
        state = '';
      }
      return state;
    }

    /**
     * Returns the state selected by the user using `global/state-selector-module`.
     * @returns {string} A two-letter state abbreviation (e.g. "NC").
     */
  }, {
    key: "getUserSelectedState",
    value: function getUserSelectedState() {
      return this._getState();
    }

    /**
     * @private
     * Sets the state code in session storage (locally) or in a cookie.
     * @param {string} state - A two-letter state abbreviation (e.g. "NC").
     * @returns {string|false} The persisted state abbreviation or `false` on failure.
     */
  }, {
    key: "_setState",
    value: function _setState(state) {
      if (typeof state !== 'string' && state.length !== 2) {
        return false;
      }

      // Use local storage.
      if (_store.environment === 'LOCAL' && _store.useSessionStorage) {
        this.persist('spartaState', state, 'sessionStorage');
      } else {
        // Set a cookie.
        spartaGlobalFunctions.spartaSetCookie('state', state, 365, true);
      }
      return state;
    }
  }]);
}();
var index = new SpartaStoreUtility();
export { index as default };